<style scoped>
.topbar-wrapper {
	max-width: 7.5rem;
    width: 100%;
	position: fixed;
	top: 0;
	z-index: 5;
	text-align: center;
	font-size: .36rem;
	line-height: 1rem;
	background-color: #FFF;
}
.topbar {
	height: 1rem;
	position: relative;
	box-sizing: border-box;
	border-bottom: 1px solid #EEE;
	/*font-weight: bold;*/
}
.back {
	width: .25rem;
	height: 100%;
	position: absolute;
	left: .3rem;
}
.back::before,.back::after{
	content: "";
	width: .25rem;
	height: 1px;
	position: absolute;
	top: 50%;
	left: 0;
	background-color: #282F3C;
	transform-origin: left center;
	transform: translateY(-50%) rotate(-45deg);
}
.back::after{
	transform: translateY(-50%) rotate(45deg)
}
</style>

<template>
	<div class="topbar-wrapper">
		<div class="topbar">
			<span v-if="!hideBackBtn" class="back" @click="back"></span>

			{{text}}

		</div>
	</div>
</template>

<script>
	export default {
		props: ['text', 'hideBackBtn'],
		methods: {
			back() {
                var ua = navigator.userAgent;
				// if(this.$route.query.type==1){
                //     var isIos = /iPhone/i.test(ua);
                //     var isAndroid = /Android/i.test(ua);
                //     isIos && window.webkit.messageHandlers.BackToNormal.postMessage(1);
                //     isAndroid && XinMaoEap.finshActivity();
				// }else{
                    history.back()
				// }
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/topbar.vue